<ng-template #defaultList>
  <div class="attributes-list">
    <ng-container
      *ngFor="let attr of limitedAttributes; let index = index; trackBy: trackByAttribute"
    >
      <rt-tag
        [name]="attr.value"
        [deletable]="!isReadOnly && removableAttributes[attr.id!]"
        [disabled]="isReadOnly || attr.processing"
        (deleteClick)="delete.emit(attr)"
        [wrapText]="true"
        [isHoverable]="tagsHoverable"
        [isClickable]="tagsClickable"
        [attr.margin-top-small-xx]="hasMarginTop || null"
        margin-right-small-xx
        margin-bottom-small-xx
      ></rt-tag>
    </ng-container>
    <rt-button
      *ngIf="itemsLimit && attributes.length > itemsLimit"
      variant="outline"
      size="small"
      (click)="toggleShowedOverLimit()"
      [attr.margin-bottom-small-xx]="hasMarginBottom ? '' : null"
      [attr.margin-top-small-xx]="hasMarginTop || null"
      margin-right-small-xx
    >
      {{
        showedOverLimit
          ? ('rtu.common.show_less' | translate)
          : ('rtu.common.show_more_count' | translate : { count: attributes.length - itemsLimit })
      }}
    </rt-button>
    <ng-container *ngIf="hasTrigger && (canPick || canCreate)">
      <rt-icon-button
        #origin="rtOverlayOrigin"
        rt-overlay-origin
        (click)="toggleDropdown(origin)"
        [pressed]="dropdown.open"
        variant="outline"
        iconName="add"
        shape="square"
        size="small"
        [disabled]="isReadOnly"
        [attr.margin-top-small-xx]="hasMarginTop || null"
        [attr.margin-bottom-small-xx]="hasMarginBottom ? '' : null"
      >
      </rt-icon-button>
    </ng-container>
  </div>
</ng-template>

<ng-container *ngTemplateOutlet="listTemplate; context: listContext"></ng-container>

<ng-template
  #dropdown="rtConnectedOverlay"
  [positions]="dropdownPositions"
  [hasBackdrop]="dropdownAutoCloseOnUnpreventedClick"
  (backdropClick)="onBackdropClick(dropdown.origin)"
  rt-connected-overlay
>
  <rt-attributes-select
    [text]="attributesTexts"
    [showAlreadyExists]="attributeAlreadyExists"
    [resetOnSaveFromInput]="resetOnSaveFromInput"
    [resetOnSaveFromSuggestion]="resetOnSaveFromSuggestion"
    [loading]="suggestionsData.isLoading"
    [width]="hasTriggerWidth ? getTriggerWidth() : '300px'"
    [canPick]="canPick"
    [canCreate]="canCreate"
    [createDisabled]="createDisabled"
    [maxDropdownHeight]="maxDropdownHeight"
    [suggestions]="suggestionsData"
    [initialValue]="initialValue"
    [maxLength]="maxLength"
    [selectFooterTemplate]="selectFooterTemplate"
    [selectHeaderTemplate]="selectHeaderTemplate"
    [hasSearch]="hasSearch"
    [control]="control"
    (save)="save.emit($event)"
    (query)="handleQueryChange($event)"
    (dispose)="toggleDropdown(dropdown.origin)"
    (loadMore)="loadMore.emit($event)"
  >
  </rt-attributes-select>
</ng-template>
